import { atom } from 'jotai'

/**
 * Jotai atom storing the enabled state of the API error simulator.
 * State is in-memory only and resets on page refresh.
 * Persisted across Dialog open/close cycles so the toggle survives unmounts.
 */
export const errorSimulatorEnabledAtom = atom<boolean>(false)

/**
 * Jotai atom storing the URL pattern used by the API error simulator.
 * Persisted in global state so the interceptor manager (mounted outside the
 * Dialog) can read the latest value even after the UI panel unmounts.
 */
export const errorSimulatorUrlPatternAtom = atom<string>('/')

/**
 * Jotai atom storing the HTTP error status code for the API error simulator.
 * Persisted in global state for the same reason as errorSimulatorUrlPatternAtom.
 */
export const errorSimulatorErrorStatusAtom = atom<number>(500)
